// extracted by mini-css-extract-plugin
export var info = "styles-module--info--f10f4";
export var inner = "styles-module--inner--56e67";
export var list = "styles-module--list--9e4b3";
export var page = "styles-module--page--945fd";